import { render, staticRenderFns } from "./EditRgpLens.vue?vue&type=template&id=8b4b0dde&scoped=true&"
import script from "./EditRgpLens.vue?vue&type=script&lang=js&"
export * from "./EditRgpLens.vue?vue&type=script&lang=js&"
import style0 from "./EditRgpLens.vue?vue&type=style&index=0&id=8b4b0dde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4b0dde",
  null
  
)

export default component.exports